import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { INQUIRY_TYPES_CANDIDATES } from '../../../define/consts/solution_order';
import { propBool, propFunc, propShape, } from '../../../helpers/custom-prop-types';
import IsAllLoadingHoc from '../../Layout/Loading/IsAllLoadingHoc';
import Banner from '../../Ui/Solution/Banner';
import FormOrderInquiry from './FormOrderInquiry';
const OrderContent = (props) => {
    const { isProffit, item, submitOrder } = props;
    return (_jsx("div", Object.assign({ className: 'l-container l-contents' }, { children: _jsxs("div", Object.assign({ className: 'l-container-9 l-contents-main' }, { children: [_jsx(Banner, { headerClass: 'banner-header', isClient: true, isDemo: false, item: item, onClickOrder: null, showFitButton: false }), _jsx("section", Object.assign({ className: 'content-box' }, { children: _jsx(FormOrderInquiry, { initialValues: {
                            orderType: INQUIRY_TYPES_CANDIDATES[0].value,
                        }, isProffit: isProffit, onSubmit: submitOrder }) }))] })) })));
};
OrderContent.propTypes = {
    isProffit: propBool().isRequired,
    item: propShape(),
    submitOrder: propFunc().isRequired,
};
OrderContent.defaultProps = {
    item: null,
};
export default IsAllLoadingHoc(OrderContent);
